// import React from 'react';
// import ReactDOM from 'react-dom';
// import axe from 'react-axe';

import './src/assets/stylesheets/styles.scss';

// export const onInitialClientRender = () => {
//   if (process.env.NODE_ENV === 'development') {
//     axe(React, ReactDOM, 1000);
//   }
// };
